import * as Actions from 'store/actions/app/sales_cpe.actions'
import { toggleIdInArray } from 'utils/toggle-id-in-array'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'

const initialState = {
  loading_sales_cpe: false,
  sales_cpe: [],
  total_sales_cpe: 0,

  sending_sale_to_sunat_ids: [],
  sent_sale_to_sunat_ids: [],

  sending_uninformed_sales_to_sunat: false,
  sent_uninformed_sales_to_sunat_ids: [],
}

const salesCPEReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SALES_CPE: {
      return {
        ...state,
        loading_sales_cpe: action.payload.loading ?? state.loading_sales_cpe,
        sales_cpe: action.payload.items ?? state.sales_cpe,
        total_sales_cpe: action.payload.total ?? state.total_sales_cpe,
      }
    }
    case Actions.SEND_SALE_TO_SUNAT: {
      return {
        ...state,
        sending_sale_to_sunat_ids: toggleIdInArray(state.sending_sale_to_sunat_ids, action.payload.sending_id),
        sent_sale_to_sunat_ids: toggleIdInArray(state.sent_sale_to_sunat_ids, action.payload.sent_id),
        sales_cpe: action.payload.data
          ? addOrUpdateObjectInArray(state.sales_cpe, action.payload.data, 'facturacion_id')
          : state.sales_cpe
      }
    }
    case Actions.SEND_UNINFORMED_SALES_TO_SUNAT: {
      return {
        ...state,
        sending_uninformed_sales_to_sunat: action.payload.sending ?? state.sending_uninformed_sales_to_sunat,
        sent_uninformed_sales_to_sunat_ids: action.payload.data ?? [],
      }
    }
    case Actions.RESTORE_SALE_STOCK_REJECTED: {
      return {
        ...state,
        sending_sale_to_sunat_ids: toggleIdInArray(state.sending_sale_to_sunat_ids, action.payload.restoring_id),
      }
    }
    default: {
      return state
    }
  }
}

export default salesCPEReducer